import { Injectable } from '@angular/core';
import { AppConfig } from './app-config';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor() { }

  current : AppConfig;

  load() : Promise<any> {
    console.log('app config svc load');
    return fetch('assets/app-config.json')
    .then(resp => resp.json())
    .then(json => { this.current = json });
  }
}
